module.exports = __webpack_public_path__ + "static/heroOlympo325-5604a76d688c0de77d7cfcb3de31a857.png";